import {
  Customer,
  Order,
  ScheduledOrder,
  Site,
  Supplier,
} from '@iss/libs/graphql';

export const AppRoutingPaths = {
  CONSENT_APPROVAL: 'consent-approval',
  ORDERS: 'orders',
  ORDERS_PENDING: 'pending',
  ORDERS_CONFIRMED: 'confirmed',
  UPLOAD_WEIGHTS: 'upload-weights',
  UPLOAD_WEIGHTS_DELIVERED: 'delivered',
  UPLOAD_WEIGHTS_RFI: 'ready-for-invoicing',
  SCHEDULES: 'schedules',
  CUSTOMERS: 'customers',
  CUSTOMERS_DOCUMENTS: 'documents',
  CUSTOMERS_LIST: 'list',
  CUSTOMERS_SITES: 'sites',
  CUSTOMERS_SITES_EQUIPMENT: 'equipment',
  LOGOUT: 'logout',
  NEW_ORDER: 'new-order',
  SUPPLIERS: 'suppliers',
  SUPPLIERS_DOCUMENTS: 'documents',
  INVOICING: 'invoicing',
  REPORTS: 'reports',
  EMPLOYEES: 'employees',
  ADMIN: 'admin',
  ADMIN_PURCHASE_PRICE: 'purchase-price',
  ADMIN_SALES_PRICE: 'sales-price',
  ADMIN_USERS: 'users',
  ADMIN_PROCESSES: 'processes',
  ADMIN_SYSTEM: 'system',
  AUTHORIZE: 'authorize',
  NOT_AUTHORIZED: 'not-authorized',
  GLOBAL_ERROR: 'global-error',
  ACCOUNT: 'account',
  APP_CONTEXT: 'app-context',
  LOGIN: 'login',
};

export const AppRoutingLinks = {
  account: () => [ '/', AppRoutingPaths.ACCOUNT ],
  appContext: () => [ '/', AppRoutingPaths.APP_CONTEXT ],
  orders: () => [ '/', AppRoutingPaths.ORDERS ],
  confirmedOrders: () => [ ...AppRoutingLinks.orders(), AppRoutingPaths.ORDERS_CONFIRMED ],
  confirmedOrder: (id: Order['id']) => [ ...AppRoutingLinks.confirmedOrders(), id ],
  uploadWeight: () => [ '/', AppRoutingPaths.UPLOAD_WEIGHTS ],
  uploadWeightDelivered: () => [ ...AppRoutingLinks.uploadWeight(), AppRoutingPaths.UPLOAD_WEIGHTS_DELIVERED ],
  uploadWeightRfi: () => [ ...AppRoutingLinks.uploadWeight(), AppRoutingPaths.UPLOAD_WEIGHTS_RFI ],
  schedules: () => [ ...AppRoutingLinks.orders(), AppRoutingPaths.SCHEDULES ],
  schedule: (id: ScheduledOrder['id']) => [ ...AppRoutingLinks.schedules(), id ],
  pendingOrders: () => [ ...AppRoutingLinks.orders(), AppRoutingPaths.ORDERS_PENDING ],
  pendingOrder: (id: Order['id']) => [ ...AppRoutingLinks.pendingOrders(), id ],
  newOrder: () => [ '/', AppRoutingPaths.NEW_ORDER ],
  sites: () => [ '/', AppRoutingPaths.CUSTOMERS, AppRoutingPaths.CUSTOMERS_SITES ],
  site: (id: Site['id']) => [ ...AppRoutingLinks.sites(), id ],
  suppliers: () => [ '/', AppRoutingPaths.SUPPLIERS ],
  supplier: (id: Supplier['id']) => [ ...AppRoutingLinks.suppliers(), id ],
  customers: () => [ '/', AppRoutingPaths.CUSTOMERS, AppRoutingPaths.CUSTOMERS_LIST ],
  customer: (id: Customer['id']) => [ ...AppRoutingLinks.customers(), id ],
  customerDocuments: (id: Customer['id']) => [ ...AppRoutingLinks.customer(id), AppRoutingPaths.CUSTOMERS_DOCUMENTS ],
  invoicing: () => [ '/', AppRoutingPaths.INVOICING ],
  reports: () => [ '/', AppRoutingPaths.REPORTS ],
  admin: () => [ '/', AppRoutingPaths.ADMIN ],
  login: () => [ '/', AppRoutingPaths.LOGIN ],
  logout: () => [ '/', AppRoutingPaths.LOGOUT ],
};
